import { useState } from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Panel, Table, RagBadge, useLoad, Loading, FormDialog } from "@/components/common";
import { useNavigate } from "react-router-dom";

export default function Reports({ p, reload }) {
  const nav = useNavigate();
  const { data, error } = useLoad(() => api.get(`/projects/${p.id}/reports`).then((r) => r.data), [p.id]);
  const [open, setOpen] = useState(false);
  if (!data) return <Loading error={error} />;
  const canPublish = ["pm", "pgm"].includes(p.my_role) && !p.locked;
  return (
    <>
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-500">The report snapshot (RAG, financials, milestones, top RAID) is generated automatically — you only add the narrative.</p>
        {canPublish && <Button data-testid="generate-report-btn" onClick={() => setOpen(true)}><FileText className="mr-1 h-4 w-4" />Generate & publish status report</Button>}
      </div>
      <Panel title="Published status reports" testid="reports-panel">
        <Table testid="reports-table" rows={data} empty="No reports yet" cols={[{ k: "week", h: "Week" }, { k: "summary", h: "Summary", r: (r) => <Link to={`/reports/${r.id}`} className="text-indigo-700 hover:underline" data-testid={`report-${r.id}`}>{r.summary.slice(0, 90)}</Link> },
          { k: "rag", h: "Overall", r: (r) => <RagBadge value={r.rag?.overall} /> }, { k: "author", h: "Author" }]} />
      </Panel>
      <FormDialog open={open} onOpenChange={setOpen} title="Weekly status report" testid="report-form" submitLabel="Publish to stakeholders"
        fields={[{ name: "summary", label: "Executive summary", type: "textarea", required: true, help: "Two or three sentences: where are we, what's changed, what's at risk." },
          { name: "achievements", label: "Achievements this period", type: "textarea" }, { name: "next_period", label: "Planned next period", type: "textarea" },
          { name: "decisions_needed", label: "Decisions needed", type: "textarea", help: "e.g. Approve contingency drawdown of 20k" }]}
        onSubmit={async (v) => { const r = await api.post(`/projects/${p.id}/reports`, v); reload(); nav(`/reports/${r.data.id}`); }} />
    </>
  );
}
